import { Navigate } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthContext';

/** Root `/`: send unauthenticated users to login, authenticated users to dashboard. */
export default function HomeRedirect() {
  const { isAuthenticated } = useAuth();
  return <Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />;
}
